import { LinkTargetUrlField } from "../link-target-url-field";

import type { UseSupabaseLoaderState } from "../../../../../server/supabase/hooks/types";
import type { Asset } from "../../../../assets/server/digital-asset-service";
import type { TagGroup } from "../../../../merge-tag/components/types";
import type { MomentFormSurvey } from "../../../../survey/server/supabase-survey-service";
import type { LinkType } from "./types";
import type { FC } from "react";
import type { FieldError } from "react-hook-form";

interface Props {
  linkOption: LinkType;
  value: string | null;
  onChange: (value: string) => void;
  assetsLoader?: UseSupabaseLoaderState<Asset[]> & { reload: () => void };
  surveyLoader: UseSupabaseLoaderState<MomentFormSurvey[]>;
  error?: FieldError;
  filterTags: (x: string) => TagGroup;
}

export const StyleableButtonUrl: FC<Props> = ({
  linkOption,
  value,
  onChange,
  error,
  assetsLoader,
  filterTags,
  surveyLoader,
}) => (
  <LinkTargetUrlField
    linkOption={linkOption}
    value={value}
    onChange={onChange}
    assetsLoader={assetsLoader}
    surveyLoader={surveyLoader}
    error={error}
    filterTags={filterTags}
    urlLabel="Button Link"
  />
);
